/*
 Funções em JS puro utizadas pelas telas de Login e Registro
*/
import MobileDetect from "mobile-detect";
import getURLParams from "../shared/getURLParams";
import { CHECKOUT_API } from "../shared/constants";
import { showModalCheckoutError, getModalCheckoutError } from "./modalCheckoutErrors";
import { setCookie, CookieTypes } from "../shared/cookie";

const SEARCH_FLIGHTS_PREFIX = "/busca-passagens-aereas/";

export const redirectLoggedUser = (_location = window.location) => {
	const fieldCreateOffer = localStorage.getItem("CreateOffer");
	const offerReferrer = fieldCreateOffer ? JSON.parse(fieldCreateOffer).referrer : undefined;
	let checkoutId = window.sessionStorage.getItem("activeCheckoutId");
	let referrer = document.referrer;

	if (checkoutId && referrer.match(/\/pagamento/)) {
		window.location = `${SEARCH_FLIGHTS_PREFIX}pagamento?id=${checkoutId}`;
		_location = `${SEARCH_FLIGHTS_PREFIX}pagamento?id=${checkoutId}`;
	}
	else if (offerReferrer) {
		window.location = offerReferrer;
		_location = offerReferrer;
	}
	else {
		if (referrer && referrer.indexOf(document.location.hostname) > -1 && referrer.indexOf("/cadastro") === -1) {
			window.location = referrer;
			_location = referrer;
		} else {
			window.location = document.location.origin;
			_location = document.location.origin;
		}
	}
};

export const urlCheckout = checkoutId => `${CHECKOUT_API}/checkouts/${checkoutId}`;

export const requestSuccess = code => {
	return code >= 200 && code < 300 ? true : false;
};

/**
 * retorna o id do checkout atual
 */
export const getCheckoutId = (
	_sessionStorage = window.sessionStorage,
	_location = window.location,
	_localStorage = window.localStorage
) => {
	return _sessionStorage.getItem("activeCheckoutId")
		? _sessionStorage.getItem("activeCheckoutId")
		: getURLParams(_location.href).id;
};

export const trimInput = node => {
	node.onchange = event => {
		node.value = event.target.value.trim();
	};
};

export const storeToken = token => {
	localStorage.setItem("au", token);
	setCookie("au", token, CookieTypes.REQUIRED);
};

/**
 * Seletor simples estilo jquery
 * @param {Object} selector
 */
export const $ = item => {
	const element = document && document.getElementById(item.substr(1));
	if (element === null) {
		const selector = document.querySelectorAll(item);

		if (selector !== null && selector.length > 1) {
			return extractValues(selector);
		}

		if (selector !== null && selector.length == 1) {
			return selector[0];
		}

		return null;
	} else {
		return element;
	}
};
/**
 * Alternativa a extractValues (indisponível no safari)
 */
export const extractValues = obj => {
	var concat = [];
	for (var i in obj) {
		if (obj.hasOwnProperty(i)) {
			concat.push(obj[i]);
		}
	}
	return concat;
};

/**
 * Checa se o valor é vazio/inválido
 * @param value a ser checado
 * @returns {boolean}
 */
export const checkEmptyValue = value => {
	return value === "" || value === null || typeof value === "undefined";
};

/**
 * pega as informações de lastClick, cookie afiliados, preenche 'data' para enviar para dito
 * @params {String} lastClick informação do lastClick
 * @params {String} cookieCac informação do cookieCac afiliados
 * @returns {Object}
 */
export const sendCookieDito = (lastClick, cookieCac) => {
	const parser = new MobileDetect(window.navigator.userAgent || navigator.userAgent);
	let deviceMobileModel = parser.mobile() || parser.tablet() ? "mobile" : "desktop"
	let deviceMobileBrand = parser.phone()

	let data = {
		app: false
	};

	data.marca_dispositivo = "desktop";
	if (deviceMobileBrand != undefined) {
		data.marca_dispositivo = deviceMobileBrand;
	}

	data.modelo_dispositivo = "desktop";
	if (deviceMobileModel != undefined) {
		data.modelo_dispositivo = deviceMobileModel;
	}

	if (lastClick != undefined) {
		lastClick = JSON.parse(lastClick);

		if (lastClick.utm_source) {
			data.utm_source_last_click = lastClick.utm_source;
		}
		if (lastClick.utm_medium) {
			data.utm_medium_last_click = lastClick.utm_medium;
		}
		if (lastClick.utm_medium) {
			data.utm_campaing_last_click = lastClick.utm_campaing;
		}
	}

	if (cookieCac != undefined) {
		cookieCac = JSON.parse(cookieCac);

		if (cookieCac.utm_source) {
			data.utm_source_afiliados = cookieCac.utm_source;
		}
		if (cookieCac.utm_medium) {
			data.utm_medium_afiliados = cookieCac.utm_medium;
		}
		if (cookieCac.utm_medium) {
			data.utm_campaing_afiliados = cookieCac.utm_campaing;
		}
	}

	return data;
};

export const verifyCheckoutId = () => {
	const checkoutId = getCheckoutId();

	if (checkoutId) {
		nanoajax.ajax({ url: urlCheckout(checkoutId) }, (code, response) => {
			const responseObj = JSON.parse(response);
			if (!requestSuccess(code)) {
				const errorContent = getModalCheckoutError(code);
				showModalCheckoutError(errorContent);
			}
		});
	}
};
